import { createReducer } from '@reduxjs/toolkit';
import { setGooglePayButtonVisibility } from '../../actions/googlePay/common';
import { type GooglePayStore } from '../../types/StoreState';

export const googlePayButtonInitialState: GooglePayStore['button'] = {
  visibility: 'initial',
};

export const googlePayButtonReducer = createReducer(googlePayButtonInitialState, (builder) => {
  builder.addCase(setGooglePayButtonVisibility, (state, action) => {
    state.visibility = action.payload;
  });
});
